import React, { useState, useEffect } from 'react';
import { getRecentActivity } from '../services/adminService';
import { pageContainer, cardStyle, sectionTitle, tableSearch } from '../styles/theme';
import Paginator from '../components/Paginator';
import PageHeader from '../components/PageHeader';

const ActivityLog = () => {
  const [activities, setActivities] = useState<any[]>([]);
  const [loading, setLoading]       = useState(true);
  const [search, setSearch]         = useState('');
  const [page, setPage]             = useState(1);
  const pageSize = 15;

  const fetchActivity = async () => {
    setLoading(true);
    const data = await getRecentActivity();
    setActivities(data || []);
    setLoading(false);
  };

  useEffect(() => {
    fetchActivity();
  }, []);

  const filtered = activities.filter(act => 
    !search || 
    act.service?.name?.toLowerCase().includes(search.toLowerCase()) || 
    act.customer?.user?.name?.toLowerCase().includes(search.toLowerCase())
  );

  const paged = filtered.slice((page - 1) * pageSize, page * pageSize);

  return (
    <div style={pageContainer}>
      <PageHeader
        breadcrumb="Dashboard > Activity Log"
        title="System Activity Log"
        subtitle="Monitor real-time system events, user actions, and bookings across the platform."
        onRefresh={fetchActivity}
      />

      <div style={cardStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, marginBottom: 20 }}>
          <h3 style={{ ...sectionTitle, margin: 0 }}>All Activities</h3>
          <input
            type="text" 
            placeholder="Search activities…"
            style={{ ...tableSearch, minWidth: 240 }}
            value={search} 
            onChange={e => { setSearch(e.target.value); setPage(1); }}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {loading ? (
            <p style={{ padding: "40px", textAlign: "center", color: "#94a3b8" }}>Loading activities...</p>
          ) : paged.length === 0 ? (
            <p style={{ padding: "40px", textAlign: "center", color: "#94a3b8" }}>No activities found.</p>
          ) : (
            paged.map((act, i) => (
              <div
                key={act.id || i}
                style={{ 
                  display: "flex", gap: "16px", padding: "12px", 
                  borderRadius: "8px", border: "1px solid #f1f5f9",
                  background: "#f8fafc"
                }}
              >
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "#e0e7ff",
                    color: "#2563eb",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                  }}
                >
                  ⚡
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>
                    New Booking: {act.service?.name || "Service"}
                  </div>
                  <div style={{ fontSize: "13px", color: "#64748b", margin: "4px 0" }}>
                    User <span style={{ fontWeight: 600 }}>{act.customer?.user?.name || "Unknown"}</span> booked this service.
                  </div>
                </div>
                <div style={{ fontSize: "12px", color: "#94a3b8", textAlign: "right" }}>
                  {new Date(act.createdAt).toLocaleString()}
                </div>
              </div>
            ))
          )}
        </div>

        {!loading && filtered.length > 0 && (
          <div style={{ marginTop: "24px" }}>
            <Paginator total={filtered.length} page={page} pageSize={pageSize} onPage={setPage} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ActivityLog;
